module.exports = __webpack_public_path__ + "img/prf.b9cd26b9.png";